import { useState, useEffect, useRef } from 'react';
import { useWhatsAppLead } from '@/hooks/useWhatsAppLead';

const faqCategories = [
  {
    label: 'Genel',
    icon: 'ri-information-line',
    faqs: [
      {
        q: 'Kurulum ne kadar sürer?',
        a: 'Paketinize bağlı olarak kurulum genellikle 24–48 saat içinde tamamlanır. Smart Vitrin paketinde çoğu zaman aynı gün yayına alınabiliyoruz.',
      },
      {
        q: 'İstediğimde iptal edebilir miyim?',
        a: 'Evet, herhangi bir taahhüt yoktur. İstediğiniz zaman aboneliğinizi sonraki fatura döneminden itibaren iptal edebilirsiniz. Kilitli sözleşme imzalamıyoruz.',
      },
      {
        q: 'Mevcut web sitem varsa ne olur?',
        a: 'Mevcut sitenizi kapatmanıza gerek yok. Smart Hizmet Satış Platformu mevcut sitenizin yanına ya da alt domaine kurulabilir. Hangi yapının daha verimli olacağını birlikte değerlendiririz.',
      },
      {
        q: 'Teknik bilgi gerekiyor mu?',
        a: 'Hayır, hiç teknik bilgi gerekmez. Kurulum, entegrasyon ve yayına alma süreçlerini biz yönetiyoruz. Siz sadece gelen müşterilere odaklanın.',
      },
      {
        q: 'WhatsApp entegrasyonu nasıl çalışır?',
        a: 'Platforma eklenen WhatsApp butonu, ziyaretçiyi tek tıkla doğrudan sizin WhatsApp numaranıza yönlendirir. İsteğe bağlı olarak önceden hazırlanmış mesaj şablonu da ayarlanabilir.',
      },
      {
        q: 'Reklam yönetimi de dahil mi?',
        a: 'Platform kurulumu ve reklam entegrasyonu desteği dahildir. Reklam bütçesi ve yönetimi ayrı fiyatlandırılır; isterseniz bu konuda da size özel teklif hazırlayabiliriz.',
      },
    ],
  },
  {
    label: 'Paket Karşılaştırması',
    icon: 'ri-layout-grid-line',
    faqs: [
      {
        q: 'Smart Vitrin ile Smart Satış Platformu arasındaki fark nedir?',
        a: 'Smart Vitrin, işletmenizin dijital varlığını oluşturmak için temel bir tanıtım sayfasıdır. Smart Satış Platformu ise buna ek olarak funnel yapısı, kampanya sayfaları, lead toplama ve temel analiz içerir — yani sadece görünmekle kalmaz, aktif olarak müşteri getirir.',
      },
      {
        q: 'Smart Pro Platform\'u kimler tercih etmeli?',
        a: 'Reklam harcamalarını optimize etmek, ziyaretçi davranışlarını detaylı analiz etmek ve tek panelden reklam siparişi vermek isteyen işletmeler için idealdir. Büyüme hedefli, veri odaklı çalışmak isteyenlerin tercihi.',
      },
      {
        q: 'Orta paket ile üst paket arasındaki en kritik fark nedir?',
        a: 'Smart Satış Platformu temel funnel, kampanya sayfaları ve form toplama sunar. Smart Pro ise bunlara ek olarak gelişmiş davranış analizi, adım adım kullanıcı takibi, kampanya bazlı detaylı performans raporu ve doğrudan reklam sipariş modülü içerir. Kısacası Pro, veriye dayalı büyüme için tasarlanmıştır.',
      },
      {
        q: 'Hangi paketten başlamalıyım?',
        a: 'Eğer henüz dijital varlığınız yoksa Smart Vitrin ile başlayabilirsiniz. Aktif müşteri kazanmak istiyorsanız Smart Satış Platformu en dengeli seçimdir. Reklam + analiz + platform üçlüsünü tek elden yönetmek istiyorsanız Smart Pro\'yu tercih edin.',
      },
      {
        q: 'Paket yükseltme yapabilir miyim?',
        a: 'Evet, istediğiniz zaman daha üst pakete geçiş yapabilirsiniz. Geçiş anında fark ücret alınır ve yeni özellikler aynı gün aktive edilir.',
      },
    ],
  },
  {
    label: 'Fiyatlandırma',
    icon: 'ri-price-tag-3-line',
    faqs: [
      {
        q: 'Fiyatlara KDV dahil mi?',
        a: 'Hayır, belirtilen fiyatlara KDV dahil değildir. Faturanıza %20 KDV ilave edilir. Yıllık ödeme tercihinde 2 ay ücretsiz fırsatı sunuyoruz.',
      },
      {
        q: 'Yıllık ödeme seçeneği nasıl çalışır?',
        a: 'Yıllık ödeme tercih ettiğinizde 12 ay yerine 10 ay ücret ödersiniz — yani 2 ay tamamen ücretsiz. Ödeme tek seferlik yapılır ve yıl boyunca fiyat değişmez.',
      },
      {
        q: 'Gizli ücret var mı?',
        a: 'Hayır. Paket fiyatı dışında kurulum ücreti, aktivasyon ücreti veya sürpriz ek ücret yoktur. Reklam bütçesi ve özel entegrasyonlar ayrı değerlendirilir, bunlar önceden net şekilde belirtilir.',
      },
      {
        q: 'Özel fiyat teklifi alabilir miyim?',
        a: 'Evet. Birden fazla şube, özel entegrasyon veya kurumsal ihtiyaçlarınız varsa size özel teklif hazırlıyoruz. WhatsApp üzerinden bize ulaşmanız yeterli.',
      },
      {
        q: 'Ödeme yöntemleri nelerdir?',
        a: 'Kredi kartı, banka havalesi ve EFT ile ödeme yapabilirsiniz. Kurumsal fatura düzenlenmektedir.',
      },
    ],
  },
];

export default function FAQSection() {
  const [activeCategory, setActiveCategory] = useState(0);
  const [open, setOpen] = useState<number | null>(null);
  const ref = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);
  const { openModal } = useWhatsAppLead();

  useEffect(() => {
    setOpen(null);
    // Kategori değişince yeni soruları animate et
    if (listRef.current) {
      listRef.current.querySelectorAll('.faq-item').forEach((el, i) => {
        (el as HTMLElement).style.opacity = '0';
        (el as HTMLElement).style.transform = 'translateY(20px)';
        setTimeout(() => {
          (el as HTMLElement).style.opacity = '1';
          (el as HTMLElement).style.transform = 'translateY(0)';
        }, i * 80);
      });
    }
  }, [activeCategory]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.faq-item').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 80);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const currentFaqs = faqCategories[activeCategory].faqs;

  return (
    <section
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #0a0a0f 0%, #0d0d18 100%)' }}
    >
      <div className="absolute top-0 left-0 right-0 section-divider pointer-events-none" />
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{ backgroundImage: 'radial-gradient(ellipse at 50% 0%, #00d4ff, transparent 55%)' }}
      />

      <div className="max-w-3xl mx-auto px-4 md:px-8" ref={ref}>
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-neon/10 border border-neon/20 px-4 py-2 rounded-full mb-5">
            <i className="ri-question-answer-line text-neon text-sm" />
            <span className="text-neon text-sm font-semibold">Sıkça Sorulan Sorular</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-4 tracking-tight">
            Aklınızdaki{' '}
            <span className="text-gold-gradient">Sorular</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-xl mx-auto">
            Henüz cevap bulamadıysanız WhatsApp üzerinden bize yazın, anında yanıt verelim.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex items-center justify-center gap-2 mb-10 flex-wrap">
          {faqCategories.map((cat, idx) => (
            <button
              key={cat.label}
              onClick={() => setActiveCategory(idx)}
              type="button"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap pointer-events-auto ${
                activeCategory === idx
                  ? 'bg-gold text-dark'
                  : 'bg-white/5 text-gray-400 border border-white/8 hover:border-white/20 hover:text-white'
              }`}
            >
              <i className={`${cat.icon} text-sm`} />
              {cat.label}
            </button>
          ))}
        </div>

        {/* FAQ List */}
        <div className="space-y-3" ref={listRef}>
          {currentFaqs.map((faq, idx) => (
            <div
              key={`${activeCategory}-${idx}`}
              className="faq-item"
              style={{ opacity: 1, transform: 'translateY(0)', transition: 'all 0.4s ease' }}
            >
              <button
                onClick={() => setOpen(open === idx ? null : idx)}
                className={`w-full text-left glass rounded-2xl px-6 py-5 flex items-center justify-between gap-4 transition-all duration-300 cursor-pointer group ${
                  open === idx
                    ? 'border border-gold/30 bg-gold/5'
                    : 'border border-white/5 hover:border-white/10'
                }`}
              >
                <span className={`font-semibold text-base transition-colors ${open === idx ? 'text-white' : 'text-gray-200 group-hover:text-white'}`}>
                  {faq.q}
                </span>
                <span
                  className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                    open === idx
                      ? 'bg-gold text-dark rotate-45'
                      : 'bg-white/5 text-gray-400 group-hover:bg-white/10'
                  }`}
                >
                  <i className="ri-add-line text-sm font-black" />
                </span>
              </button>

              {/* Answer */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  open === idx ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pt-3 pb-5 text-gray-400 leading-relaxed text-sm border-x border-b border-gold/20 rounded-b-2xl -mt-2 bg-gold/[0.03]">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm mb-4">Başka bir sorunuz mu var?</p>
          <button
            onClick={() => openModal('SSS — WhatsApp\'tan Sorun')}
            className="btn-outline-neon inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line" />
            WhatsApp&apos;tan Sorun
          </button>
        </div>
      </div>
    </section>
  );
}
